import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { AuthService } from "../services/auth.service"

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService:AuthService
    ,private router:Router
  ) { }

  ngOnInit() {
  }

  logout() {
    this.authService.logout().then((resp) => {
      if (resp.redirectUrl) {
        window.location.href = resp.redirectUrl;
      }
      else {
        this.router.navigate(['/']);
      }
    })
    .catch((error) => {
      console.error(error);
      this.router.navigate(['/']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/logout/logout.component.ts